<template>
  <div class="d-flex align-center">
    <v-divider vertical :class="$vuetify.display.smAndDown ? 'mx-1' : 'mx-2'" />
    <v-btn :class="[{ 'pr-2': showMap }, { 'px-1': $vuetify.display.smAndDown }]">
      <v-switch :model-value="showMap" hide-details @update:model-value="updateViewMode">
        <template #label>
          <span :class="[`${showMap ? 'text-primary' : 'text-grey-lighten-1'}`]" class="map-switch__label">
            Map
          </span>
        </template>
      </v-switch>
      <template v-if="showMap">
        <v-divider vertical :class="$vuetify.display.smAndDown ? 'mx-1' : 'mx-2'" />
        <v-menu location="bottom start">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              :class="{ 'mr-0': !$vuetify.display.xs }"
              :size="$vuetify.display.smAndDown ? 'small' : undefined"
            >
              mdi-menu-down
            </v-icon>
          </template>
          <v-list subheader>
            <v-list-item @click="setStoreMapView('clusters')">
              <template #prepend>
                <v-icon class="mr-2">mdi-checkbox-multiple-blank-circle</v-icon>
              </template>
              <div>
                <v-list-item-title>Map with Clusters</v-list-item-title>
              </div>
            </v-list-item>
            <v-list-item @click="setStoreMapView('points')">
              <template #prepend>
                <v-icon class="mr-2">mdi-map-marker-circle</v-icon>
              </template>
              <v-list-item-title>Map with Points</v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item @click="setStoreMapView('clusters-full')">
              <template #prepend>
                <v-icon class="mr-2">mdi-checkbox-multiple-blank-circle</v-icon>
              </template>
              <div>
                <v-list-item-title>Full Map with Clusters</v-list-item-title>
              </div>
            </v-list-item>
            <v-list-item @click="setStoreMapView('points-full')">
              <template #prepend>
                <v-icon class="mr-2">mdi-map-marker-circle</v-icon>
              </template>
              <v-list-item-title>Full Map with Points</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapMutations } from 'vuex';

import { SET_MAP_VIEW } from '@/store/modules/spatial/spatial-types';

interface IData {
  showMap: boolean;
}

export default defineComponent({
  name: 'AppFiltersPanelMapSwitch',

  emits: ['update:view-mode'],

  data: (): IData => ({
    showMap: false
  }),

  created () {
    this.$eventBus.$on('close:map-view', this.closeMapViewHandler);
  },

  beforeUnmount () {
    this.$eventBus.$off('close:map-view', this.closeMapViewHandler);
  },

  methods: {
    ...mapMutations('Spatial', {
      setStoreMapView: SET_MAP_VIEW,
    }),
    updateViewMode (value: boolean) {
      this.showMap = value;
      this.$emit('update:view-mode', value ? 'map' : 'list');
    },
    closeMapViewHandler () {
      if (!this.showMap) {
        return;
      }

      this.updateViewMode(false);
    },
  }
})
</script>

<style scoped lang="scss">
:deep(.map-switch__label) {
  font-size: 14px;
  letter-spacing: 1.25px;
}
</style>
